import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { fmtNow } from "@/lib/time";

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// sections: [{ title, headers: [...], rows: [[...]] }]
export function downloadCSV(filename, sections) {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  let csv = "";
  sections.forEach((s) => {
    csv += `${s.title}\n`;
    csv += `${s.headers.map(esc).join(",")}\n`;
    s.rows.forEach((r) => { csv += `${r.map(esc).join(",")}\n`; });
    csv += "\n";
  });
  triggerDownload(new Blob([csv], { type: "text/csv;charset=utf-8;" }), filename);
}

export function downloadReportPDF(filename, title, org, sections) {
  const doc = new jsPDF();
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.setTextColor(11, 45, 91); // navy
  doc.text("RideStamp", 14, 18);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.setTextColor(51, 65, 85);
  doc.text(title, 14, 25);
  doc.setFontSize(9);
  doc.setTextColor(100, 116, 139);
  doc.text(`${org} · Generated ${fmtNow()}`, 14, 31);

  let y = 38;
  sections.forEach((s) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(11, 45, 91);
    doc.text(s.title, 14, y);
    autoTable(doc, {
      startY: y + 2,
      head: [s.headers],
      body: s.rows,
      headStyles: { fillColor: [37, 99, 235], textColor: 255, fontStyle: "bold" },
      styles: { fontSize: 9, cellPadding: 2.5 },
      alternateRowStyles: { fillColor: [243, 244, 246] },
      margin: { left: 14, right: 14 },
      theme: "striped",
    });
    y = doc.lastAutoTable.finalY + 10;
    if (y > 265) { doc.addPage(); y = 20; }
  });

  doc.save(filename);
}
